<template>
<Campaigns />
</template>

<script>
import Campaigns from '../../components/ContactCenter/CampaignsComponent.vue';

export default {
    components: {
        Campaigns,
    },
};
</script>
